import {
  ServiceRequestDetails,
} from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';

export enum ServiceRequestDetailsListExtensibleFields {
  OUTPUT_FILES = 'OUTPUT_FILES',
  ISSUES = 'ISSUES',
  SECURE_INFORMATION_REQUESTS = 'SECURE_INFORMATION_REQUESTS',
  NPS_TASK = 'NPS_TASK',
  WORKFLOW_EXECUTION = 'WORKFLOW_EXECUTION',
}

export type TUseAllServiceRequestDetailsOptions = {
  corporationId?: number;
  companyId?: number;
  serviceRequestIds?: string[];
  serviceCompositeIds?: string[];
  isCommendaFiling?: boolean;
  extends?: ServiceRequestDetailsListExtensibleFields[];
};

export const useAllServiceRequestDetails = (
  options?: TUseAllServiceRequestDetailsOptions
) => {
  const { corporationId, companyId, serviceRequestIds, serviceCompositeIds, isCommendaFiling, extends: extendsFields } = options ?? {};
  const query = new URLSearchParams();

  if (corporationId) {
    query.append('corporationId', corporationId.toString());
  }

  if (companyId) {
    query.append('companyId', companyId.toString());
  }

  if (serviceRequestIds && serviceRequestIds.length > 0) {
    query.append('serviceRequestIds', serviceRequestIds.join(','));
  }

  if (serviceCompositeIds && serviceCompositeIds.length > 0) {
    query.append('serviceCompositeIds', serviceCompositeIds.join(','));
  }

  if (isCommendaFiling !== undefined) {
    query.append('isCommendaFiling', String(isCommendaFiling));
  }

  if (extendsFields && extendsFields.length > 0) {
    query.append('extends', extendsFields.join(','));
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: ServiceRequestDetails[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    query.toString() ? `${API_BASE_PATH}/list?${query.toString()}` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
};
